import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';
import { ConsumoHorasRegalo } from './consumoHorasRegaloService';

const url = 'consumo-horas-regalo/';

export interface PosGiftBenefit {
    id: number; cliente: number; nombre: string; sesion: number | null;
    minutos_disponibles: number; en_curso: boolean;
    fecha_inicio_periodo: string; fecha_fin_periodo: string;
}
export const posGiftBenefits = (sesion_pos: number, cliente?: number, uso_horas_regalo?: number): Promise<PosGiftBenefit[]> =>
    handleRequestWithAuth(async () => (await axiosInstance.get(`${url}beneficios_pos/`, {params: {sesion_pos, cliente, uso_horas_regalo}})).data);
export const posGiftOptions = (sesion_pos: number, uso_horas_regalo: number, precio_plan_servicio?: number): Promise<GiftOptions> =>
    handleRequestWithAuth(async () => (await axiosInstance.get(`${url}opciones_pos/`, {params: {sesion_pos, uso_horas_regalo, precio_plan_servicio}})).data);
export const startPosGift = (data: {sesion_pos: number; uso_horas_regalo: number; espacio_servicio: number; precio_plan_servicio: number}, token: string): Promise<GiftRequest> =>
    handleRequestWithAuth(async () => (await axiosInstance.post(`${url}iniciar_manual/`, data, {headers: {'X-POS-Operator-Token': token}})).data);
export interface GiftOption {
    precio_plan_servicio: number; servicio: string; plan: string;
    espacio_servicio: number; espacio: string; sucursal: number; sucursal_nombre: string;
    proximas_ocupaciones?: {inicio: string; fin: string | null}[];
    disponible?: boolean; ocupaciones?: {inicio: string; fin: string | null}[];
}
export interface GiftOptions {
    opciones: GiftOption[]; minutos_disponibles: number; fecha_inicio_periodo: string;
    fecha_fin_periodo: string; fin_beneficio: string; servidor_ahora: string;
}
export interface GiftRequest {
    id: number; estado: 'pendiente' | 'registrada' | 'cancelada' | 'vencida';
    uso_horas_regalo: number; fecha_programada: string; duracion_minutos: number;
    vence_en: string; servidor_ahora: string; qr: string | null;
    cliente: string; sucursal: string; servicio: string; espacio: string;
    consumo: ConsumoHorasRegalo | null; operador: string | null; sesion_pos: number | null;
}
export const giftQrOptions = (id: number, availability?: {fecha_programada: string; sucursal: number; precio_plan_servicio: number}): Promise<GiftOptions> => handleRequestWithAuth(async () =>
    (await axiosInstance.get(`${url}opciones_qr/`, { params: { uso_horas_regalo: id, ...availability } })).data);
export const giftQrRequests = (id: number): Promise<GiftRequest[]> => handleRequestWithAuth(async () =>
    (await axiosInstance.get(`${url}mis_solicitudes/`, { params: { uso_horas_regalo: id } })).data);
export const requestGiftQr = (data: {uso_horas_regalo: number; espacio_servicio: number; precio_plan_servicio: number;
    sucursal: number; fecha_programada: string}): Promise<GiftRequest> =>
    handleRequestWithAuth(async () => (await axiosInstance.post(`${url}solicitar_qr/`, data)).data);
export const cancelGiftQr = (id: number): Promise<GiftRequest> => handleRequestWithAuth(async () =>
    (await axiosInstance.post(`${url}cancelar_solicitud/`, { id })).data);
export const scanGiftQr = (qr: string, sesion_pos: number, token: string): Promise<GiftRequest> =>
    handleRequestWithAuth(async () => (await axiosInstance.post(`${url}validar_qr/`, { qr, sesion_pos },
        { headers: { 'X-POS-Operator-Token': token } })).data);
export const giftQrError = (error: any): string => {
    const data = error?.response?.data;
    if (typeof data === 'string') return data;
    if (data?.detail) return String(data.detail);
    return data ? Object.values(data).flat().join(' ') : 'No se pudo completar la operación. Vuelve a intentar.';
};

export const posGiftQrHistory = (sesion_pos: number): Promise<GiftRequest[]> => handleRequestWithAuth(async () =>
    (await axiosInstance.get(`${url}seguimiento_qr/`, { params: { sesion_pos } })).data);
export const posFinishGiftQr = (id: number, sesion_pos: number, token: string): Promise<GiftRequest> =>
    handleRequestWithAuth(async () => (await axiosInstance.post(`${url}finalizar_qr/`, { id, sesion_pos },
        { headers: { 'X-POS-Operator-Token': token } })).data);

export interface GiftUsageDetail {
    id: number; cliente: string; espacio: string; servicio: string; sucursal: string;
    registrado_por: string | null; saldo_minutos: number; servidor_ahora: string;
    consumo: ConsumoHorasRegalo;
}
export const giftUsageDetail = (consumo_id: number, sesion_pos: number): Promise<GiftUsageDetail> => handleRequestWithAuth(async () =>
    (await axiosInstance.get(`${url}detalle_uso/`, {params: {consumo_id, sesion_pos}})).data);
